import { ReactComponent as TickIcon } from 'assets/images/elearning/navigation/tick_icon.svg';
import clsx from 'clsx';
import Heading from 'components/universal/heading';
import { BREAKPOINTS } from 'constants/breakpoints';
import { useTopic } from 'hooks/useTopic';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useMedia } from 'react-use';
import { Issue } from 'types/elearning';
import cls from './accordion.module.scss';
import { ListItem } from './list-item';

interface IProps {
    issues: Issue[];
    className?: string;
    isAccordionOpen: boolean
}

export const Accordion: FC<IProps> = ({ issues, className, isAccordionOpen }) => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.courseLayout.issues',
    });
    const { pathname } = useLocation();
    const isLg = useMedia(BREAKPOINTS.LG);
    
    const { courseData } = useTopic();

    const clsAccordion = clsx(cls.accordion, {
        [className]: Boolean(className),
        [cls.accordionOpen]: isAccordionOpen,
    });

    const clsListWrapper = clsx(cls.listWrapper, {
        [cls.listWrapperOpen]: isAccordionOpen,
    });

    const clsSpace = clsx(cls.space, {
        [cls.spaceOpen]: isAccordionOpen,
    });

    const currentIssue =
        courseData &&
        courseData?.issues?.find?.((issue) =>
            pathname?.includes?.(issue?.path)
        );

    return (
        <div className={clsAccordion}>
            {(!isLg && !isAccordionOpen) && (
                <>
                    <div className={`${cls.line} ${cls.lineMobile}`}></div>
                    <button
                        aria-label={
                            isAccordionOpen ? t('collapseList') : t('expandList')
                        }
                        className={cls.headingWrapper}
                    >
                        <Heading className={cls.heading} headingLevel="h4" fontWeight={700}>
                            <div
                                className={clsx(cls.itemStatus, {
                                    [cls.itemStatusDone]: currentIssue?.is_done,
                                })}
                            >
                                <TickIcon />
                            </div>
                            {currentIssue?.name || currentIssue?.topics[0]?.name}
                        </Heading>
                    </button>
                    <div className={`${cls.line} ${cls.lineMobile}`}></div>
                    <div className={clsSpace}></div>
                </>
            )}
            <div className={cls.line}></div>
            <div className={clsListWrapper}>
                <ul className={cls.list}>
                    {issues?.map?.((issue) => (
                        <Fragment key={issue?.path}>
                            <ListItem topic={issue} path={issue?.path} prefixPath={courseData?.path} />
                        </Fragment>
                    ))}
                </ul>
            </div>
        </div>
    );
};
